import strings from './strings.json';

export const replaceTenantSpecificData = (
    body: string,
    tenantName = 'default'
): string => {
    Object.keys(strings).forEach((placeholder) => {
        const stringValues = strings[placeholder as keyof typeof strings];
        body = body.replace(
            new RegExp(placeholder, 'g'),
            stringValues[tenantName as keyof typeof stringValues] ??
                stringValues.default
        );
    });

    return body;
};
